export const SECTION_LABEL_CLASSNAME =
  "text-xs font-semibold uppercase tracking-wide text-subtle";
